export default __webpack_public_path__ + "assets/images/f506e401dddb2003770ef8fe0ea5d293.png";